import React from 'react';
import { Download } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { brandLabel, downloadReceipt, fmtDate, fmtMoney } from '@/lib/billingApi';
import { StatusPill } from './StatusPill';

const method = (p) => (p.gateway === 'paypal' ? 'PayPal' : p.card_last4 ? `${brandLabel(p.card_brand)} •••• ${p.card_last4}` : 'Card');
const kindLabel = { initial: '', renewal: 'Renewal · ', renewal_manual: 'Renewal · ' };

const ReceiptBtn = ({ p }) => (p.receipt_id ? (
  <Button size="sm" variant="ghost" className="h-8 px-2 text-[#00247D]" onClick={() => downloadReceipt(p.receipt_id, p.receipt_number).catch((e) => toast.error(e.message))}
    data-testid={`history-receipt-${p.id}`}><Download className="w-4 h-4 mr-1" />{p.receipt_number}</Button>
) : <span className="text-xs text-slate-400">—</span>);

export const BillingHistory = ({ payments }) => {
  if (!payments.length) return <p className="text-sm text-slate-500 py-6 text-center" data-testid="billing-history-empty">No payments yet.</p>;
  return (
    <>
      <div className="hidden md:block overflow-x-auto" data-testid="billing-history-table">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-[11px] uppercase tracking-wide text-slate-400 border-b border-slate-200">
            <th className="py-2 pr-3">Date</th><th className="py-2 pr-3">Description</th><th className="py-2 pr-3">Method</th>
            <th className="py-2 pr-3 text-right">Amount</th><th className="py-2 pr-3">Status</th><th className="py-2">Receipt</th>
          </tr></thead>
          <tbody>{payments.map((p) => (
            <tr key={p.id} className="border-b border-slate-100 last:border-0" data-testid={`history-row-${p.id}`}>
              <td className="py-3 pr-3 whitespace-nowrap text-slate-600">{fmtDate(p.paid_at || p.created_at)}</td>
              <td className="py-3 pr-3 font-medium text-slate-800">{kindLabel[p.kind] || ''}{p.product_name}</td>
              <td className="py-3 pr-3 text-slate-600 whitespace-nowrap">{method(p)}</td>
              <td className="py-3 pr-3 text-right font-semibold whitespace-nowrap">{fmtMoney(p.total, p.currency)}</td>
              <td className="py-3 pr-3"><StatusPill status={p.status} label={p.status_label} testId={`history-status-${p.id}`} /></td>
              <td className="py-3"><ReceiptBtn p={p} /></td>
            </tr>
          ))}</tbody>
        </table>
      </div>
      <div className="md:hidden space-y-3" data-testid="billing-history-cards">
        {payments.map((p) => (
          <div key={p.id} className="rounded-xl border border-slate-200 p-3">
            <div className="flex justify-between gap-2"><span className="font-semibold text-sm text-slate-800">{p.product_name}</span><span className="font-bold text-sm">{fmtMoney(p.total, p.currency)}</span></div>
            <div className="flex items-center justify-between gap-2 mt-2"><span className="text-xs text-slate-500">{fmtDate(p.paid_at || p.created_at)} · {method(p)}</span><StatusPill status={p.status} label={p.status_label} /></div>
            {p.receipt_id && <div className="mt-1 -ml-2"><ReceiptBtn p={p} /></div>}
          </div>
        ))}
      </div>
    </>
  );
};
